var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.isAdminNotConsultant(_vm.loggedUserData) ? _c("div", {
    staticClass: "submenus"
  }, [_vm.canManage ? _c("router-link", {
    staticClass: "router-link --no-hover-underlined",
    attrs: {
      to: {
        query: {
          tab: _vm.tabs.users
        }
      }
    }
  }, [_c("div", {
    staticClass: "submenus-item",
    class: [_vm.selectedTab === _vm.tabs.users ? "submenus-item--active" : ""]
  }, [_c("span", [_vm._v("Users")])])]) : _vm._e(), _vm.canManageUserSignUpLinks ? _c("router-link", {
    staticClass: "router-link --no-hover-underlined",
    attrs: {
      to: {
        query: {
          tab: _vm.tabs.signUpLink
        }
      }
    }
  }, [_c("div", {
    staticClass: "submenus-item",
    class: [_vm.selectedTab === _vm.tabs.signUpLink ? "submenus-item--active" : ""]
  }, [_c("span", [_vm._v("Sign Up Links")])])]) : _vm._e()], 1) : _vm._e();
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };